const endpoint = property => `/api/${ property }/events/treatments`;

export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    save: treatment => {
      let url = treatment.id ? `${ endpoint(api.property()) }/${ treatment.id }` : endpoint(api.property());

      return api.upload(url, treatment).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    toggleActive: id => {
      return api.get(`${ endpoint(api.property()) }/status/${ id }`)
        .then(response => response.data);
    },
    toggleVisible: id => {
      return api.get(`${ endpoint(api.property()) }/visible/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property()) }?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    },
    reconstruct: order => {
      return api.post(`${ endpoint(api.property()) }/reconstruct`, order)
      .then(response => response.data);
    },
    updatePriority: treatment => {
      return api.post(`${ endpoint(api.property() )}/${ treatment.id}/priority?priority=${treatment.priority}`)
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/treatment/services/treatments.service.js